// extracted by mini-css-extract-plugin
export default {"cta":"aG-z","disabled":"bG-z"};